import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import LessonPage from './pages/LessonPage';
import CoursePage from './pages/CoursePage';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import RefundPage from './pages/RefundPage';
import AdminPage from './pages/AdminPage';
import CertificatePage from './pages/CertificatePage';
import './styles/globals.css';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-center"><div className="spinner" /></div>;
  return user ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Navbar />
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/courses" element={<HomePage />} />
            <Route path="/courses/:slug" element={<CoursePage />} />
            <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
            <Route path="/learn/:slug/:moduleId/:lessonId" element={<PrivateRoute><LessonPage /></PrivateRoute>} />
            <Route path="/learn/:slug/:moduleId" element={<PrivateRoute><LessonPage /></PrivateRoute>} />
            <Route path="/admin/*" element={<PrivateRoute><AdminPage /></PrivateRoute>} />
            <Route path="/certificates" element={<PrivateRoute><CertificatePage /></PrivateRoute>} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/refund-policy" element={<RefundPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

function PlainPage({ title, content }) {
  return (
    <div style={{ maxWidth: '760px', margin: '0 auto', padding: '48px 24px' }}>
      <h1 style={{ marginBottom: '24px' }}>{title}</h1>
      <div style={{ fontSize: '16px', lineHeight: '1.75', color: 'var(--color-text-body)' }} dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
}

const PRIVACY = `<p>PropertyTraining.ai is committed to protecting your personal data in accordance with the UK GDPR and the Data Protection Act 2018.</p><h3>What we collect</h3><p>We collect your name, email address, and course progress data when you register and use our platform. Payment processing is handled entirely by Stripe — we never store your card details.</p><h3>How we use it</h3><p>Your data is used solely to provide the PropertyTraining.ai service, including course access, progress tracking, and AI tutor interactions.</p><h3>Your rights</h3><p>You have the right to access, correct, or delete your personal data at any time. Contact us at hello@propertytraining.ai to exercise these rights.</p><h3>Contact</h3><p>Data controller: PropertyTraining.ai. Email: hello@propertytraining.ai</p><p><em>Last updated: March 2026</em></p>`;

const TERMS = `<p>These terms govern your use of PropertyTraining.ai. By purchasing a course, you agree to these terms.</p><h3>Course access</h3><p>Upon successful payment, you receive lifetime access to the purchased course. Access is personal and non-transferable.</p><h3>Content</h3><p>All course content is for educational purposes only and does not constitute financial, legal, or tax advice. Always seek professional advice for your individual circumstances.</p><h3>Refunds</h3><p>If you are unsatisfied with a course, contact us within 14 days of purchase for a full refund.</p><h3>Contact</h3><p>hello@propertytraining.ai</p><p><em>Last updated: March 2026</em></p>`;

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AppRoutes />
      </ToastProvider>
    </AuthProvider>
  );
}
